const TOKEN_KEY = 'access_token'
const REFRESH_TOKEN_KEY = 'refresh_token'

/**
 * Manage the how Access Tokens are being stored and retreived from storage.
 *
 * Current implementation stores to localStorage. Local Storage should always be
 * accessed through this instace.
**/
const TokenService = {
    getToken() {
        return localStorage.getItem(TOKEN_KEY)
    },

    saveToken(accessToken) {
        localStorage.setItem(TOKEN_KEY, accessToken)
    },

    removeToken() {
        localStorage.removeItem(TOKEN_KEY)
    },

    getRefreshToken() {
        return localStorage.getItem(REFRESH_TOKEN_KEY)
    },

    saveRefreshToken(refreshToken) {
        localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken)
    },

    removeRefreshToken() {
        localStorage.removeItem(REFRESH_TOKEN_KEY)
    }

}

const settings = {
    sidebar: '',
    minutes: ''
}

const SettingsService = {
    
    saveSidebarSettings(sidebar) {
        settings.sidebar = sidebar
        localStorage.setItem('SETTINGS', JSON.stringify(settings))
    },
    saveMinutesSettings(minutes) {
        settings.minutes = minutes
        localStorage.setItem('SETTINGS', JSON.stringify(settings))
    },
    // getMinutesSettings() {
    //     settings.minutes = minutes
    //     localStorage.setItem('SETTINGS', JSON.stringify(settings))
    // },
    getSidebarSettings() {
        var resp = localStorage.getItem('SETTINGS', settings)
        if (resp) {
            return JSON.parse(resp).sidebar
        }
    }
    
}

export { TokenService, SettingsService }